import { useCallback } from 'react';
import { useLegacyMessaging, type LegacyRawMessage } from '@/shared/lib/legacyMagic';
import { exchangeToken } from '@/api/generated/auth/auth';

type OttData = NonNullable<LegacyRawMessage['data']> & { ott?: string };

const OTT_TIMEOUT_MS = 10_000;

export function useOttExchange() {
  const { send, isPending } = useLegacyMessaging();

  const exchange = useCallback(
    (): Promise<void> =>
      new Promise<void>((resolve, reject) => {
        const timeoutId = setTimeout(
          () => reject(new Error('OTT request timed out')),
          OTT_TIMEOUT_MS
        );

        send('get-ott', {}, (msg) => {
          clearTimeout(timeoutId);
          const ott = (msg.data as OttData | undefined)?.ott;
          if (!ott) {
            reject(new Error('Missing OTT in legacy response'));
            return;
          }
          exchangeToken({ token: ott })
            .then(() => resolve())
            .catch((e: unknown) => reject(e));
        });
      }),
    [send]
  );

  return { exchange, isPending };
}
